<template>
  <section>
    <h3 class="title text-center" v-if="!tramite">{{ $t('verificar.title') }}</h3>
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="verificar" class="grid-form" v-if="!tramite">
          <div class="alert alert-info">
            <i class="icon-info"></i> {{ $t('fields.verificar_documento') }}
          </div>
          <div class="grid verificar">
            <div class="form-group required" :class="{ 'error-input': errors.has('nro_legalizacion') }">
              <label for="nro_legalizacion">{{ $t('fields.nro_legalizacion') }}</label>
              <input
                type="text"
                v-model="form.nro_legalizacion"
                name="nro_legalizacion"
                id="nro_legalizacion"
                v-validate="'required'"
                maxlength="10"
                autocomplete="off"
                class="form-control">
              <span v-show="errors.has('nro_legalizacion')" class="error-help">{{ errors.first('nro_legalizacion') }}</span>
            </div>
            <div class="form-group required" :class="{ 'error-input': errors.has('cod_seguridad') }">
              <label for="cod_seguridad">{{ $t('fields.cod_seguridad') }}</label>
              <input
                type="text"
                v-model="form.cod_seguridad"
                name="cod_seguridad"
                id="cod_seguridad"
                v-validate="'required'"
                maxlength="20"
                autocomplete="off"
                class="form-control">
              <span v-show="errors.has('cod_seguridad')" class="error-help">{{ errors.first('cod_seguridad') }}</span>
            </div>
            <date-select
              :required="true"
              :label="$t('fields.fecha_expedicion')"
              model="solicitud.fecExpedicion"></date-select>
            <div class="form-group">
              <label for="">&nbsp;</label>
              <button class="btn btn-primary" type="submit">{{ $t('btn.verificar') }} <i class="icon-checkmark"></i></button>
            </div>
          </div>
        </form>
        <div v-if="tramite" class="detalle grid-form">
          <h3 class="title">Información de su trámite</h3>
          <div class="alert alert-success"><i class="icon-checkmark"></i> Su documento se encuentra legalizado/certificado correctamente</div>
          <div class="documentos">
            <div class="documento">
              <h4 class="title">{{ tramite.documento_nombre }}</h4>
              <p>{{ tramite.documento_descripcion }}</p>
              <p class="entidad"><small>{{ tramite.documento_entidad_nombre }}</small></p>
              <div class="grid cols-3">
                <div class="form-group">
                  <label><strong>{{ $t('fields.nro_legalizacion') }}</strong></label>
                  <p class="form-control"><strong>{{ form.nro_legalizacion }}</strong></p>
                </div>
                <div class="form-group">
                  <label>{{ $t('fields.cod_seguridad') }}</label>
                  <p class="form-control">{{ form.cod_seguridad }}</p>
                </div>
                <div class="form-group">
                  <label>{{ $t('fields.fecha_expedicion') }}</label>
                  <p class="form-control">{{ $util.formatDate($store.state.solicitud.fecExpedicion) }}</p>
                </div>
              </div>
              <h4 class="title">Datos Personales</h4>
              <div class="grid datos-personales">
                <div class="form-group">
                  <label>{{ $t('fields.nombre_solicitante') }}</label>
                  <p class="form-control">{{ tramite.tramite_solicitante_nombres }} {{ tramite.tramite_solicitante_primer_apellido }} {{ tramite.tramite_solicitante_segundo_apellido }}</p>
                </div>
                <div class="form-group">
                  <label>{{ $t('fields.tipoDoc') }}</label>
                  <p class="form-control">{{ tramite.tramite_solicitante_tipo_documento }}</p>
                </div>
                <div class="form-group">
                  <label>{{ $t('fields.nroDoc') }}</label>
                  <p class="form-control">{{ tramite.tramite_solicitante_nro_documento }}</p>
                </div>
                <!-- div class="form-group">
                  <label>{{ $t('fields.fecha_nacimiento') }}</label>
                  <p class="form-control">{{ $util.formatDate(tramite.tramite_solicitante_fecha_nacimiento) }}</p>
                </div -->
              </div>
            </div>
          </div>
          <pdf-view v-if="showPdf" :data="tramite.pdf" :url="tramite.url"></pdf-view>
          <div class="btn-container">
            <button class="btn" @click="back">{{ $t('btn.back') }} <i class="icon-arrow-left2"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DateSelect from '@/components/util/DateSelect';
import PdfView from '@/components/util/PdfView';

const tipoDocs = {
  CI: 'CÉDULA DE IDENTIDAD',
  EXTRANJERO: 'DOCUMENTO DE IDENTIFICACIÓN EXTRANJERO'
};

export default {
  components: { DateSelect, PdfView },
  data () {
    return {
      data: {},
      form: {
        nro_legalizacion: '',
        cod_seguridad: ''
      },
      tramite: null,
      tipoDocs,
      showPdf: false
    };
  },

  created () {
    if (this.$route.params.nro_legalizacion &&
      this.$route.params.cod_seguridad &&
      this.$route.params.fecha_expedicion) {
      let data = {
        code: this.$route.params.cod_seguridad,
        number: this.$route.params.nro_legalizacion,
        date: this.$route.params.fecha_expedicion
      };

      this.$service.post(`verificar`, data)
        .then(response => {
          if (response) {
            this.showPdf = false;
            this.$nextTick(() => {
              response.url = this.$apiUrl + response.url;
              this.form.cod_seguridad = data.code;
              this.form.nro_legalizacion = data.number;
              this.$store.state.solicitud.fecExpedicion = data.date;
              this.tramite = response;
              this.showPdf = true;
            });
          }
        });
    }
  },
  methods: {
    async verificar () {
      this.$store.commit('setValid', true);
      if (await this.$validator.validateAll() && !this.$filter.empty(this.$store.state.solicitud.fecExpedicion)) {
        let data = {
          code: this.form.cod_seguridad,
          number: this.form.nro_legalizacion,
          date: this.$store.state.solicitud.fecExpedicion
        };
        this.$service.post(`verificar`, data)
        .then(response => {
          if (response) {
            this.showPdf = false;
            this.$nextTick(() => {
              response.url = this.$apiUrl + response.url;
              this.tramite = response;
              this.showPdf = true;
            });
          }
        });
      }
    },
    back () {
      this.tramite = null;
      this.form = {
        nro_legalizacion: '',
        cod_seguridad: ''
      };
      this.$store.commit('setSolicitud', {});
    }
  }
};
</script>

<style lang="scss">
@import 'pages.scss';

.grid {
  &.verificar {
    grid-template-columns: 3fr 3fr 4fr 2fr;
  }

  &.datos-personales {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
}

.detalle {
  .documento {
    border: none;

    .entidad {
      margin-bottom: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Verificar.vue